// extracted by mini-css-extract-plugin
module.exports = {"optionWrapper":"style_optionWrapper__1WHrx","option":"style_option__BzRmL","icon":"style_icon__3LmCf"};